import { useNavigate } from "react-router-dom";

import useDisplay from "../../../hooks/useDisplay";
import LSRgH2HeadLine from "../../molecules/text/linSeedKr/Rg/lsRgH2HeadLine";
import styled from "styled-components";
import LSRgH1HeadLine from "../../molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import { fileUrl } from "../../../api/api";
import { route } from "../../../router/route";
import { formatNumberWithCommas } from "../../../util/formatNumber";

function LectureItem({ data, isMiddle }) {
  const navigate = useNavigate();
  const { isMobile, isTablet, isDesktop } = useDisplay();

  return (
    <>
      <HoverContainer
        onClick={() => {
          navigate(`${route.lecture_detail}/${data.id}`);
        }}
        isMobile={isMobile}
        isMiddle={isMiddle}
        isTablet={isTablet}
      >
        <div
          style={{
            borderRadius: 15,
            overflow: "hidden",
          }}
        >
          <ZoomImage
            isMobile={isMobile}
            isMiddle={isMiddle}
            src={
              data?.thumbnailServerFileName
                ? `${fileUrl}/${data.thumbnailServerFileName}`
                : ""
            }
            alt="video_temp01"
          />
        </div>

        <ProductTitle
          style={{
            fontSize: isMobile ? 16 : 18,
            lineHeight: isMobile ? "22.4px" : "25.2px",
          }}
        >
          {data.title}
        </ProductTitle>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
          }}
        >
          <LSRgH1HeadLine
            style={{
              fontSize: isMobile ? 12 : 16,
              lineHeight: isMobile ? "14.4px" : "22.4px",
              color: "#6F7480",
            }}
          >
            {data.lectureCategory?.title ?? "미분류"}
          </LSRgH1HeadLine>

          <div
            style={{
              height: isMobile ? 12 : 16,
              width: 1,
              marginLeft: 14,
              marginRight: 14,
              background: "#6F7480",
            }}
          />

          <img
            style={{
              width: 16,
              height: 16,
              marginRight: 4,
            }}
            src={"/assets/icons/star_3d.png"}
            alt="star_3d"
          />
          <LSRgH1HeadLine
            style={{
              color: "#6F7480",
              fontSize: isMobile ? 12 : 16,
              lineHeight: isMobile ? "14.4px" : "22.4px",
            }}
          >
            {data.reviewScore ? data.reviewScore?.toFixed(1) : 0} (
            {formatNumberWithCommas(data?.reviewCount)})
          </LSRgH1HeadLine>
        </div>
      </HoverContainer>
    </>
  );
}

export default LectureItem;

const ProductTitle = styled(LSRgH2HeadLine)`
  color: #101113;
  margin-top: 16px;
  margin-bottom: 4px;

  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-word;

  display: -webkit-box;
  -webkit-line-clamp: 1; // 원하는 라인수
  -webkit-box-orient: vertical;
`;

const HoverContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex: 1;
  position: relative;
  background: #fff;
  cursor: pointer;
  margin-right: ${({ isMobile, isMiddle, isTablet }) =>
    isMobile ? "15px" : isMiddle ? "29.5px" : isTablet ? "30px" : "0"};
  width: ${({ isMobile, isMiddle }) =>
    isMobile ? 200 : isMiddle ? 312 : 380}px;

  &:hover img {
    transform: scale(1.04); /* 확대 */
    transition: transform 0.3s ease-in-out; /* 부드러운 애니메이션 */
  }
`;

const ZoomImage = styled.img`
  width: ${({ isMobile, isMiddle }) =>
    isMobile ? 200 : isMiddle ? 312 : 380}px;
  height: ${({ isMobile, isMiddle }) =>
    isMobile ? 127 : isMiddle ? 198 : 242}px;
  border-radius: 15px;
`;
